export type PageWindow = {
  /** How many pages there are; never fewer than one. */
  pages: number;
  /** The page shown, clamped to what exists. */
  current: number;
  /** Row indexes of the page: `from` inclusive, `to` exclusive. */
  from: number;
  to: number;
};

/**
 * Where a page stands in a list: a page past the end shows the last one, so
 * a list that shrinks (a new answer, a filter) never shows an empty page.
 */
export const pageWindow = (
  total: number,
  page: number,
  pageSize: number
): PageWindow => {
  const size = Math.max(1, pageSize);
  const pages = Math.max(1, Math.ceil(total / size));
  const current = Math.min(Math.max(0, page), pages - 1);
  const from = Math.min(total, current * size);
  return { pages, current, from, to: Math.min(total, from + size) };
};
